import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useHistory } from 'react-router';

import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import { loginUri } from 'Consts/sharedUris';

import Box from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Box';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import RoundedButton from 'Components/ComponentLibrary/Components/Uncategorized/RoundedButton';
import { DS_SIZE_MAP } from 'Components/ComponentLibrary/DesignSystem/sizes';

import OnboardingHeader from '../../Components/Header';
import Actions from '../../Components/Actions';

const styles = theme => ({
  root: {
    padding: theme.spacing(2),
  },
});

const OnboardingNoAccess = ({
  className,
  classes,
}) => {
  const history = useHistory();
  const goToLogin = () => history.push(loginUri);

  useScrollTopOnMount();

  return (
    <Box
      className={classNames(classes.root, className)}
    >
      <OnboardingHeader
        title={'Sorry, but you do not have access to this feature.'}
        subTitle={'Please login below.'}
        centered
      />

      <Actions>
        <RoundedButton
          onClick={goToLogin}
          variant={'contained'}
          test={'completed-agreement-go-to-login-button'}
          color={'primary'}
          fullWidth
          disableElevation
          size={DS_SIZE_MAP.sm}
        >
          {'Login'}
        </RoundedButton>
      </Actions>
    </Box>
  );
};

OnboardingNoAccess.defaultProps = {
  className: '',
};

OnboardingNoAccess.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(OnboardingNoAccess);
